<div class="forgot-password-container">
    <div class="forgot-password-card">
        <div class="forgot-password-header">
            <h1>Mot de Passe Oublié</h1>
            <p *ngIf="!isSuccess && !errorMessage">Entrez votre adresse email pour recevoir les instructions de réinitialisation</p>
        </div>

        <form class="forgot-password-form" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">

            <!-- Email Field -->
            <div *ngIf="!isSuccess && !errorMessage" class="form-group">
                <label for="email">Adresse Email *</label>
                <input type="email" id="email" formControlName="email" [class.error]="hasError('email')" placeholder="Entrez votre adresse email" autocomplete="email">
                <div *ngIf="hasError('email')" class="error-message">
                    {{ getFieldError('email') }}
                </div>
            </div>

            <!-- Error Message -->
            <div *ngIf="errorMessage && !isSuccess" class="alert alert-error">
                {{ errorMessage }}
            </div>

            <!-- Success Message -->
            <div *ngIf="isSuccess" class="alert alert-success">
                <h3>Email Envoyé!</h3>
                <p>{{ successMessage }}</p>
                <p class="email-instructions">
                    Vérifiez votre boîte de réception et suivez les instructions dans l'email pour réinitialiser votre mot de passe.
                </p>
            </div>

            <!-- Submit Button -->
            <button *ngIf="!isSuccess && !errorMessage" type="submit" class="submit-btn" [disabled]="isLoading || (forgotPasswordForm.invalid && forgotPasswordForm.touched)" [class.loading]="isLoading">
                <span *ngIf="!isLoading">Envoyer les instructions</span>
                <span *ngIf="isLoading">Envoi en cours...</span>
            </button>

            <!-- Links -->
            <div class="forgot-password-links">
                <p>
                    <a [routerLink]="['/login']" class="link">← Retour à la connexion</a>
                </p>
                <p class="mt-3">
                    Pas encore de compte? <br><a [routerLink]="['/register']" class="link">Créer un compte</a>
                </p>
            </div>
        </form>
    </div>
</div>